import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
interface ParallaxImageProps {
  src: string;
  alt: string;
  className?: string;
  overlay?: boolean;
  objectPosition?: string;
}
export function ParallaxImage({
  src,
  alt,
  className = '',
  overlay = true,
  objectPosition = 'center'
}: ParallaxImageProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-15%', '15%']);
  return <div ref={ref} className={`overflow-hidden relative ${className}`} data-id="element-163">
      <motion.img src={src} alt={alt} style={{
      y,
      scale: 1.15,
      objectPosition
    }} className="absolute inset-0 w-full h-full object-cover" data-id="element-164" />
      {overlay && <div className="absolute inset-0 bg-prt-darker/70" data-id="element-165" />}
    </div>;
}